import {useState, useEffect} from 'react'
import type {ResponsiveBreakpointKey} from '@freckle/educator-materials/ts/helpers/responsive-helper'
import {getResponsiveBreakpoint} from '@freckle/educator-materials/ts/helpers/responsive-helper'
import {useWindowSize} from '@freckle/educator-materials/ts/hooks/use-window-size'

export function useResponsiveInfo(): ResponsiveBreakpointKey {
  const {width} = useWindowSize()
  const responsiveBreakpoint = getResponsiveBreakpoint(width)
  const [breakpoint, setBreakpoint] = useState<ResponsiveBreakpointKey>(responsiveBreakpoint)
  useEffect(() => setBreakpoint(responsiveBreakpoint), [responsiveBreakpoint])

  return breakpoint
}
